<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>
        <span style="color: rgb(0, 170, 221)">Dashboard /</span> Insurance
        Companies
      </p>
      <h2 class="mt-6">Insurance Companies</h2>
      <div class="cell mt-10">
        <div class="my-3 mx-10" style="display: flex; align-items: center">
          <p>Status:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{ statusSearch }}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in [
                  'All',
                  'Pending',
                  'Accepted',
                  'Rejected',
                  'Blocked',
                ]"
                :key="index"
              >
                <v-list-item-title
                  @click="
                    statusSearch = item;
                    currentPage = 1;
                    searchByStatus(item.toLowerCase());
                  "
                >
                  <p>{{ item }}</p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <p class="ml-4">Location:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{ country }}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list max-height="600" style="overflow-y: auto">
              <v-list-item
                v-for="(item, index) in $store.state.countries"
                :key="index"
              >
                <v-list-item-title
                  @click="
                    country = item.option_value;
                    countryCode = item.option_key;
                    currentPage = 1;
                    searchByStatus();
                  "
                >
                  <p>{{ item.option_value }}</p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <div class="mr-2" style="width: 15%">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              label="Search.."
              color="rgb(0,170,221)"
            ></v-text-field>
          </div>
        </div>
        <v-divider class="mx-10"></v-divider>

        <div class="d-flex flex-column">
          <div
            class="mt-8 ml-10"
            style="display: flex; align-items: center; width: 95%"
          >
            <p class="bold">{{ entries }} entries</p>
            <v-spacer></v-spacer>
            <p>Sort by</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  {{ sortByText }}
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in [
                    {
                      text: 'Date Registered (newest to oldest)',
                      value: { sort: 'dateVerified', dir: 'desc' },
                    },
                    {
                      text: 'Date Registered (oldest to newest)',
                      value: { sort: 'dateVerified', dir: 'asc' },
                    },
                    {
                      text: 'Alphabetically (ascending)',
                      value: { sort: 'taCompanyName', dir: 'asc' },
                    },
                    {
                      text: 'Alphabetically (descending)',
                      value: { sort: 'taCompanyName', dir: 'desc' },
                    },
                  ]"
                  :key="index"
                  @click="
                    sortByText = item.text;
                    sortBy = item.value.sort;
                    dir = item.value.dir;
                    searchByStatus();
                  "
                >
                  <v-list-item-title>
                    <p>{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  Display
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>
              <v-list>
                <v-list-item-group v-model="displayArray" multiple>
                  <template v-for="(item, i) in displayItems">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                      v-else
                      :key="`item-${i}`"
                      :value="item"
                      active-class="rgb(0,169,221)"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="rgb(0,169,221)"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
          <table class="align-self-center mt-2" style="width: 95%">
            <tr class="table-head">
              <th class="text-left" v-if="displayArray.includes('Name')">
                <p class="ml-2">Name</p>
              </th>
              <th class="text-left pl-2" v-if="displayArray.includes('Status')">
                <p>Status</p>
              </th>
              <th
                class="text-left"
                v-if="displayArray.includes('Date Registered')"
              >
                <p>Date Registered</p>
              </th>

              <th
                class="text-left"
                v-if="displayArray.includes('Accepted Emergency Requests')"
              >
                <p>Accepted Emergency Requests</p>
              </th>
              <th
                class="text-left"
                v-if="displayArray.includes('Closed Emergency Requests')"
              >
                <p>Closed Emergency Requests</p>
              </th>
              <th
                class="text-left"
                v-if="displayArray.includes('Pending Emergency Requests')"
              >
                <p>Pending Emergency Requests</p>
              </th>

              <!-- <th class="text-left">
                <p>
                  Accepted
                  <br />Emergencies
                </p>
              </th>
              <th class="text-left">
                <p>
                  Completed
                  <br />Appointments
                </p>
              </th>
              <th class="text-left">
                <p>
                  Avg Availability
                  <br />(last 10 days)
                </p>
              </th>-->
              <th class="text-left" v-if="displayArray.includes('Actions')">
                <p>Actions</p>
              </th>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="50"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="list-item"
                ></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader
                  height="94"
                  type="avatar"
                ></v-skeleton-loader>
              </td>
            </tr>

            <tr
              v-else
              class="table-data"
              v-for="(insurance, index) in $store.state.insurance.insurances"
              :key="index"
              @click="selectInsurance(insurance.companyProfileId)"
            >
              <td v-if="displayArray.includes('Name')">
                <p
                  style="white-space: normal"
                  class="font-weight-regular black--text"
                >
                  {{ insurance.registeredName }}
                </p>
              </td>

              <td v-if="displayArray.includes('Status')" class="pl-2">
                <div class="d-flex align-center">
                  <div
                    class="d-flex justify-center align-center"
                    v-if="insurance.BORevisedStatus === 'rejected'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="blocked"
                    ></div>
                    <p class="ml-2">Rejected</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-if="
                      insurance.taAdminUserProfile &&
                      insurance.taAdminUserProfile.isBlocked
                    "
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="blocked"
                    ></div>
                    <p class="ml-2">Blocked</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-else-if="insurance.BORevisedStatus === 'accepted'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="green"
                    ></div>
                    <p class="ml-2">Active</p>
                  </div>
                  <div
                    class="d-flex justify-center align-center"
                    v-else-if="insurance.BORevisedStatus === 'pending'"
                  >
                    <div
                      style="height: 8px; width: 8px; border-radius: 50%"
                      class="pending"
                    ></div>
                    <p class="ml-2">Pending Approval</p>
                  </div>
                </div>
              </td>

              <td v-if="displayArray.includes('Date Registered')">
                <p
                  v-if="
                    insurance.taAdminUserProfile &&
                    insurance.taAdminUserProfile.createdAt
                  "
                >
                  {{ convertDate(insurance.taAdminUserProfile.createdAt) }}
                </p>
              </td>

              <td v-if="displayArray.includes('Accepted Emergency Requests')">
                <p>0</p>
              </td>

              <td v-if="displayArray.includes('Closed Emergency Requests')">
                <p>0</p>
              </td>

              <td v-if="displayArray.includes('Pending Emergency Requests')">
                <p>0</p>
              </td>

              <!-- <td>
                <p>{{doctor.userProfile ? doctor.userProfile.acceptedEmergencies : ''}}</p>
              </td>
              
              <td>
                <p>{{doctor.userProfile ? doctor.userProfile.completedAppointments : ''}}</p>
              </td>
              <td>
                <p>{{doctor.userProfile ? doctor.userProfile.avgAvailability : ''}}%</p>
              </td>-->
              <td v-if="displayArray.includes('Actions')">
                <div class="d-flex align-center" style="cursor: pointer">
                  <v-tooltip top v-if="insurance.BORevisedStatus == 'pending'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        class="mr-2"
                        style="height: 20px; width: 20px"
                        src="/img/ban.svg"
                        alt="ban"
                        @click.stop="
                          selectedInsurance = insurance;
                          rejectDialog = true;
                        "
                      />
                    </template>
                    <span>Reject</span>
                  </v-tooltip>

                  <v-tooltip top v-if="insurance.BORevisedStatus == 'pending'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedInsurance = insurance;
                          approveDialog = true;
                        "
                      />
                    </template>
                    <span>Accept</span>
                  </v-tooltip>

                  <v-tooltip top v-if="insurance.BORevisedStatus == 'rejected'">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedInsurance = insurance;
                          approveDialog = true;
                        "
                      />
                    </template>
                    <span>Accept</span>
                  </v-tooltip>

                  <v-tooltip
                    top
                    v-if="
                      insurance.taAdminUserProfile &&
                      insurance.taAdminUserProfile.isBlocked
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="
                          selectedInsurance = insurance;
                          unblockDialog = true;
                        "
                      />
                    </template>
                    <span>Unblock</span>
                  </v-tooltip>

                  <v-tooltip
                    top
                    v-if="
                      insurance.BORevisedStatus == 'accepted' &&
                      !(
                        insurance.taAdminUserProfile &&
                        insurance.taAdminUserProfile.isBlocked
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height: 20px; width: 20px"
                        src="/img/ban/ban.png"
                        alt="ban"
                        @click.stop="
                          selectedInsurance = insurance;
                          blockDialog = true;
                        "
                      />
                    </template>
                    <span>Block</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </table>
          <div class="d-flex justify-end" style="width: 85%">
            <div class="d-flex">
              <p>Rows per page:</p>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <p class="text-capitalize ml-2 black--text" v-on="on">
                    {{ rowsPerPage }}
                    <v-icon small left>mdi-chevron-down</v-icon>
                  </p>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in [5, 10, 20, 30, 40, 50]"
                    :key="index"
                  >
                    <v-list-item-title
                      @click="
                        rowsPerPage = item;
                        currentPage = 1;
                        searchByStatus();
                      "
                      >{{ item }}</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="!!(currentPage == 1 || currentPage == 0)"
                    @click="
                      currentPage--;
                      searchByStatus();
                    "
                    >mdi-chevron-left</v-icon
                  >
                </template>
                <span>Previous</span>
              </v-tooltip>

              <p>
                Page
                <span class="black--text">{{ currentPage }}</span>
                of {{ totalPageCount }}
              </p>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="
                      !!(currentPage == totalPageCount || totalPageCount == 0)
                    "
                    @click="
                      currentPage++;
                      searchByStatus();
                    "
                    >mdi-chevron-right</v-icon
                  >
                </template>
                <span>Next</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="rejectDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Reject
              {{ selectedInsurance ? selectedInsurance.registeredName : "" }} ?
            </h1>
            <p class="text-center mt-4">
              Prevent thic company from using your services and accessing your
              network.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="rejectDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="reject(selectedInsurance)"
              >Reject</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Approve
              {{ selectedInsurance ? selectedInsurance.registeredName : "" }} ?
            </h1>
            <p class="text-center mt-4">
              The company will be considered as valid member and will be able to
              use your services and access your network.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="approveDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="approve(selectedInsurance)"
              >Approve</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Block
              {{ selectedInsurance ? selectedInsurance.registeredName : "" }} ?
            </h1>
            <p class="text-center mt-4">
              Prevent the company from being able to receive any emergency or
              appointments requests.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="block(selectedInsurance)"
              >Block</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>
              Unblock
              {{ selectedInsurance ? selectedInsurance.registeredName : "" }} ?
            </h1>
            <p class="text-center mt-4">
              This company will be re-activated and able to use your services
              again (receive emergency requests, appointments etc).
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="unblock(selectedInsurance)"
              >Unblock</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  created() {
    console.log("created");
    this.$store.dispatch("setActiveIndex", 5).then(() => {
      this.$store
        .dispatch("getAllInsurances", {
          pageSize: this.rowsPerPage,
          pageNo: 1,
          activeStatus: "all",
          sortBy: this.sortBy,
          dir: this.dir,
        })
        .then((res) => {
          this.entries = res.data.totalCount;
          this.currentPage = res.data.currentPage;
          this.totalPageCount = res.data.totalPageCount;
        })
        .catch((err) => {
          this.totalPageCount = 0;
        });
    });
  },
  data() {
    return {
      selectedInsurance: null,
      approveDialog: false,
      rejectDialog: false,
      blockDialog: false,
      unblockDialog: false,
      entries: 0,
      currentPage: 0,
      totalPageCount: null,
      currentPage: 0,
      statusSearch: "All",
      country: "All",
      sortByText: "Date Registered (newest to oldest)",
      dir: "desc",
      sortBy: "dateVerified",
      rowsPerPage: 10,
      statusSearch: "All",
      displayArray: [
        "Name",
        "Status",
        "Date Registered",
        "Accepted Emergency Requests",
        "Closed Emergency Requests",
        "Pending Emergency Requests",
        "Actions",
      ],
      displayItems: [
        "Name",
        "Status",
        "Date Registered",
        "Accepted Emergency Requests",
        "Closed Emergency Requests",
        "Pending Emergency Requests",
        "Actions",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },

  methods: {
    approve(insurance) {
      const credentials = {
        companyProfileId: insurance.companyProfileId,
        BORevisedStatus: "accepted",
      };
      this.$store.dispatch("approveInsurance", credentials).then(() => {
        this.approveDialog = false;
      });
    },
    reject(insurance) {
      const credentials = {
        companyProfileId: insurance.companyProfileId,
        BORevisedStatus: "rejected",
      };
      this.$store.dispatch("rejectInsurance", credentials).then(() => {
        this.rejectDialog = false;
      });
    },
    block(insurance) {
      const credentials = {
        userId: insurance.taAdminUserProfile.userId,
        isBlocked: true,
      };
      this.$store.dispatch("blockInsurance", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock(insurance) {
      const credentials = {
        userId: insurance.taAdminUserProfile.userId,
        isBlocked: false,
      };
      this.$store.dispatch("unblockInsurance", credentials).then(() => {
        this.unblockDialog = false;
      });
    },
    searchByStatus(status) {
      this.$store
        .dispatch("getAllInsurances", {
          pageSize: this.rowsPerPage,
          pageNo: this.currentPage,
          activeStatus: this.statusSearch.toLowerCase(),
          sortBy: this.sortBy,
          dir: this.dir,
          //  country: this.countryCode
        })
        .then((res) => {
          this.entries = res.data.totalCount;
          this.totalPageCount = res.data.totalPageCount;
          if (this.currentPage > this.totalPageCount) {
            console.log(this.currentPage, "current");
            console.log(this.totalPageCount, "total");
            console.log(this.currentPage, "current again");
          } else {
            this.currentPage = res.data.currentPage;
          }
        })
        .catch((err) => {
          console.log("xaxahxaxahx");
          this.currentPage = 0;
          this.totalPageCount = 0;
        });
    },
    convertDate(date2) {
      const date = new Date(date2);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return day + " " + this.months[month].substr(0, 3) + " " + year;
    },
    selectInsurance(id) {
      this.$router.push(`/insurances/insurance/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  color: rgb(107, 107, 107);
}

img {
  height: 35px;
  width: 35px;
  cursor: pointer;
}
</style>